import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { AngularSplitModule } from 'angular-split';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzPopoverModule } from 'ng-zorro-antd/popover';

import { MSplitLayoutControlComponent } from './split-layout-control.component';
import { MSplitLayoutComponent } from './split-layout.component';
import { MSplitLayoutService } from './split-layout.service';

@NgModule({
  imports: [CommonModule, AngularSplitModule, NzPopoverModule, NzIconModule],
  exports: [MSplitLayoutComponent, MSplitLayoutControlComponent],
  declarations: [MSplitLayoutComponent, MSplitLayoutControlComponent],
  providers: [MSplitLayoutService]
})
export class MSplitLayoutModule {}
